import i18n  from '@/lang';
export default [
  {
    path: '/analysis',
    name: '学情分析',
    component: () => import(/* webpackChunkName: "StudyAnalysis" */ '../views/StudyAnalysis/index.vue')
  },
  {
    path: '/analysis/detail',
    name: '分析详情',
    component: () => import(/* webpackChunkName: "StudyAnalysisDetail" */ '../views/StudyAnalysis/detail/detail.vue')
  },
  {
    path: '/analysis/studyAnalysis',
    name: '学生分析详情',
    component: () => import(/* webpackChunkName: "StudyAnalysisDetail" */ '../views/StudyAnalysis/studentIndex/index.vue')
  },
  {
    path: '/analysis/classNotesDetails',
    name: '课堂小结',
    component: () => import(/* webpackChunkName: "StudyAnalysisDetail" */ '../views/StudyAnalysis/classNotes/details.vue')
  },
  {
    path: '/analysis/bulletChatDetail',
    name: '弹幕详情',
    component: () => import(/* webpackChunkName: "StudyAnalysisDetail" */ '../views/StudyAnalysis/classNotes/bulletChat.vue')
  },
]